export default function getCooboId(asset) {
  let cooboId;
  let cdnUrl = asset.cdn_url_without_anchor || asset.cdn_url_without_anchor_without_voice || asset.cdn_url_with_anchor;
  if (cdnUrl) {
    console.log(cdnUrl)
    let match = cdnUrl.match(/view\/(.*)/i);
    if (match && match[1]) {
      cooboId = match[1];
    }
  }

  return cooboId;
}
